import type { Ref } from 'vue'
import { computed, ref } from 'vue'
import type { Email } from '@/types/email'
import { useCustomerExistsQuery } from '@/graphql/api/booking/customerExists.query.generated.ts'

export interface CustomerExistsLoginForm {
    fetchingCustomerExists: Ref<boolean, boolean>
    showLogin: Ref<boolean, boolean>
    closeLoginForm: () => void
    resetEmail: () => void
    getCustomerExists: () => Promise<boolean | undefined>
}

export function useCustomerExistsLoginForm(
    email: Ref<Email | ''>
): CustomerExistsLoginForm {
    const { fetching: fetchingCustomerExists, executeQuery } =
        useCustomerExistsQuery({
            variables: computed(() => ({
                email: email.value as Email,
            })),
            pause: true,
        })

    const showLogin = ref(false)

    const openLoginForm = () => {
        showLogin.value = true
    }

    const closeLoginForm = () => {
        showLogin.value = false
    }

    const resetEmail = () => {
        closeLoginForm()

        email.value = ''
    }

    const getCustomerExists = async () => {
        const result = await executeQuery()

        if (result.data.value?.customerExists) {
            openLoginForm()
        }

        return result.data.value?.customerExists
    }

    return {
        fetchingCustomerExists,
        showLogin,
        closeLoginForm,
        resetEmail,
        getCustomerExists,
    }
}
